import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'section-i',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './section-i.component.html',
  styleUrl: './section-i.component.css'
})
export class SectionIComponent implements OnInit, OnChanges {

  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection11 = new EventEmitter<any>();

  yesNo = EYesNo;
  sectionIForm: FormGroup = new FormGroup([]);

  radioQuestions = [
    {
      id: 'student_statement',
      questionText: "Are the student's statements consistent with his/her actions? *",
      formControlName: 'student_statement',
      infoFormControlName: 'student_statement_information',
      label: 'Please explain: *'
    },
    {
      id: 'student_other_knowledge',
      questionText: "Are the student's statements or explanations consistent with what others know about the situation? *",
      formControlName: 'student_other_knowledge',
      infoFormControlName: 'student_other_knowledge_information',
      label: 'Please explain: *'
    },
    {
      id: 'student_actions_consistent',
      questionText: "Are the student's actions consistent across other areas of their lives? *",
      formControlName: 'student_actions_consistent',
      infoFormControlName: 'student_actions_consistent_information',
      label: 'Please explain: *'
    },
    {
      id: 'student_current_behavior',
      questionText: "Are the student's current behaviors consistent with their past behaviors? *",
      formControlName: 'student_current_behavior',
      infoFormControlName: 'student_current_behavior_information',
      label: 'Please explain: *'
    },
    {
      id: 'student_manipulation',
      questionText: "Is there a reason to believe that the student is manipulating others in this situation? *",
      formControlName: 'student_manipulation',
      infoFormControlName: 'student_manipulation_information',
      label: 'Please explain: *'
    },
    {
      id: 'story_fabrication',
      questionText: "Is there evidence that the student has a history of fabricating stories? *",
      formControlName: 'story_fabrication',
      infoFormControlName: 'story_fabrication_information',
      label: 'Please explain: *'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      group[question.formControlName] = new FormControl(String(this.fullTeamAssessmentData?.[question.formControlName]) || this.yesNo.No, Validators.required);
      group[question.infoFormControlName] = new FormControl({ value: this.fullTeamAssessmentData?.[question.infoFormControlName] || '', disabled: this.fullTeamAssessmentData?.[question.infoFormControlName] ? false: true });
    });
    group['i_additional_info'] = new FormControl(String(this.fullTeamAssessmentData?.i_additional_info) || this.yesNo.No, Validators.required);    
    
    this.sectionIForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.sectionIForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.sectionIForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveSectionI(): void {
    if (this.sectionIForm.valid) {
      this.onSaveSection11.emit(this.sectionIForm.value);
    }
  }

}
